import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Container, FlexColumn } from "@opensea/ui-kit";
import { ContentBlockCarouselFragment } from "./components/ContentBlockCarousel/ContentBlockCarousel.fragment";
import { ContentBlockCarouselLayout } from "./components/ContentBlockCarousel/ContentBlockCarouselLayout";
import { transformGraphQLDataToCarouselProps } from "./utils/carousel-transformers";

// Layout component props based on module fragment result

export function ContentBlockModuleLayout(props) {
  const $ = _c(7);
  const t0 = props;
  let t1;
  if ($[0] !== t0) {
    const carouselData = readFragment(ContentBlockCarouselFragment, t0);
    t1 = transformGraphQLDataToCarouselProps(carouselData.sections);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    carouselType,
    sections
  } = t1;
  let t2;
  if ($[2] !== carouselType || $[3] !== props.description || $[4] !== props.title || $[5] !== sections) {
    t2 = <Container asChild={true}><FlexColumn className="flex-1 gap-10 py-(--overview-vertical-padding)"><ContentBlockCarouselLayout carouselType={carouselType} description={props.description} sections={sections} title={props.title} /></FlexColumn></Container>;
    $[2] = carouselType;
    $[3] = props.description;
    $[4] = props.title;
    $[5] = sections;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}